<template>
    <Form class="myForm" ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <Row>
            <Col :span="12">
                <FormItem label="机构类型" prop="corporateType">
                    <Input placeholder="请输入内容" v-model="formValidate.corporateType"/>
                </FormItem>
            </Col>
            <Col :span="12">
                <FormItem label="机构名称/姓名" prop="corporateName" class="small-label">
                    <Input placeholder="请输入内容" v-model="formValidate.corporateName"/>
                </FormItem>
            </Col>
            <Col :span="12">
                <FormItem label="法人代表" prop="userName">
                    <Input placeholder="请输入内容" v-model="formValidate.userName"/>
                </FormItem>
            </Col>
            <Col :span="12">
                <FormItem label="证件类型" prop="userCertificateType">
                    <Select v-model="formValidate.userCertificateType">
                        <Option v-for="item in cardList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
            </Col>
            <Col :span="12">
                <FormItem label="证件编号" prop="userCertificateNum">
                    <Input placeholder="请输入内容" v-model="formValidate.userCertificateNum"/>
                </FormItem>
            </Col>
            <Col :span="12">
                <FormItem label="联系人" prop="contacts">
                    <Input placeholder="请输入内容" v-model="formValidate.contacts"/>
                </FormItem>
            </Col>
            <Col :span="12">
                <FormItem label="联系电话" prop="userPhone">
                    <Input placeholder="请输入内容" v-model="formValidate.userPhone"/>
                </FormItem>
            </Col>
            <Col :span="12">
                <FormItem label="验证码" prop="captcha">
                    <Input placeholder="请输入内容" v-model="formValidate.captcha" style="width:40%"/>
                    <Button style="width: 55%;margin: 0 0 0 2%" @click="getCaptcha"><img :src="captchaPath"
                                                                                         style="width:95%"></Button>
                </FormItem>
            </Col>
            <Col :span="12">
                <FormItem label="联系邮箱" prop="userEmail">
                    <Input placeholder="请输入内容" v-model="formValidate.userEmail"/>
                </FormItem>
            </Col>
            <Col :span="12">
                <FormItem label="联系地址" prop="userCertificateAdds">
                    <Input placeholder="请输入内容" v-model="formValidate.userCertificateAdds"/>
                </FormItem>
            </Col>
        </Row>
        <FormItem class="align-center">
            <Button type="primary" @click="handleSubmit('formValidate')">保存</Button>
            <Button>取消</Button>
        </FormItem>
    </Form>
</template>

<script>
    import {isMobile, isIDNum, isEmail} from '@/utils/validate'
    import {updateUser, checkValidate} from '@/api/manager_user'

    export default {
        name: "basicMsg",
        props: ['userInfoData'],
        data() {
            var validatecaptcha = (rule, value, callback) => {
                if (value === '') {
                    return callback(new Error("验证码不能为空"));
                }
                return new Promise((resolve, reject) => {
                    let params = {
                        key: 'registeruser',
                        captcha: this.formValidate.captcha,
                        _dc: new Date().getTime()
                    };
                    checkValidate(params).then(response => {
                        const resData = response.data;
                        if (resData.status !== 0) {
                            this.getCaptcha();
                            callback(new Error('验证失败'));
                        } else {
                            callback();
                        }
                        resolve();
                    }).catch(error => {
                        reject(error);
                        callback(new Error('验证失败'));
                    });
                })
            };
            var checkMobile = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号不能为空'));
                } else {
                    if (!isMobile(value)) {
                        callback(new Error('手机号格式不正确'));
                    } else {
                        callback();
                    }
                }
            };
            var checkIDnum = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('身份证号不能为空'));
                } else {
                    if (!isIDNum(value)) {
                        callback(new Error('身份证号格式不正确'));
                    } else {
                        callback();
                    }
                }
            };
            var checkEmail = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('邮箱不能为空'));
                } else {
                    if (!isEmail(value)) {
                        callback(new Error('邮箱格式不正确'));
                    } else {
                        callback();
                    }
                }
            };
            return {
                formValidate: {
                    userLoginName: '',
                    corporateType: '',
                    corporateName: '',
                    userName: '',
                    userCertificateType: '',
                    userCertificateNum: '',
                    contacts: '',
                    userPhone: '',
                    captcha: '',
                    userEmail: '',
                    userCertificateAdds: ''
                },
                cardList: [
                    {
                        label: '身份证',
                        value: '身份证'
                    }
                ],
                captchaPath: '',
                ruleValidate: {
                    corporateType: [
                        {required: true, message: '请输入机构类型', trigger: 'blur'}
                    ],
                    corporateName: [
                        {required: true, message: '请输入机构名称/姓名', trigger: 'blur'}
                    ],
                    userName: [
                        {required: true, message: '请输入法人代表', trigger: 'blur'}
                    ],
                    userCertificateType: [
                        {required: true, message: '请选择证件类型', trigger: 'change'}
                    ],
                    userCertificateNum: [
                        {required: true, message: '请输入证件编号', trigger: 'blur'},
                        {validator: checkIDnum, trigger: 'blur'}
                    ],
                    contacts: [
                        {required: true, message: '请输入联系人', trigger: 'blur'}
                    ],
                    userPhone: [
                        {required: true, message: '请输入联系电话', trigger: 'blur'},
                        {validator: checkMobile, trigger: 'blur'}
                    ],
                    captcha: [
                        {required: true, message: '请输入验证码', trigger: 'blur'},
                        {validator: validatecaptcha, trigger: 'blur'}
                    ],
                    userEmail: [
                        {required: true, message: '请输入联系邮箱', trigger: 'blur'},
                        {validator: checkEmail, trigger: 'blur'}
                    ],
                    userCertificateAdds: [
                        {required: true, message: '请输入联系地址', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (!valid) {
                        return this.$Message.error('请按要求填写!');
                    }

                    return new Promise((resolve, reject) => {
                        let params = this.formValidate;
                        updateUser(params).then(response => {
                            const resData = response.data;
                            if (resData.status !== 0) {
                                this.$Message.error(resData.msg);
                            } else {
                                this.$Message.success('基本信息修改成功');
                            }
                            resolve();
                        }).catch(error => {
                            reject(error);
                            this.$Message.error('修改失败');
                        });
                    })
                })
            },
            // 获取验证码
            getCaptcha() {
                this.captchaPath = $CONFIG.BASE_API + 'user/captcha?key=registeruser&_dc=' + new Date().getTime();
            }
        },
        watch: {
            userInfoData(val){
                this.formValidate = val;
            }
        },
        mounted() {
            this.getCaptcha();
            if (this.userInfoData !== '') {
                this.formValidate = this.userInfoData;
            }
        }
    }
</script>

<style lang="less" scoped>
    @import url("../../../../static/css/common.less");

    .myForm {
        margin: 80px auto 0;

        .tips {
            margin-bottom: -15px;
            color: #C0C4CC;

            .ivu-icon {
                margin-right: 10px;
            }
        }

        .align-center {
            text-align: center;
        }

        /deep/ .small-label .ivu-form-item-label {
            line-height: 20px;
            padding: 0 12px 0 25px;
            font-size: 14px;
        }

        /deep/ .ivu-form-item {
            margin-right: 20px;
            margin-bottom: 30px;
        }

        /deep/ .ivu-form-item-label {
            padding: 12px 12px 12px 0;
            font-size: 16px;
        }

        /deep/ .ivu-input {
            height: 40px;
        }

        /deep/ .ivu-btn {
            height: 40px;
            margin-top: 100px;
            margin-right: 50px;
        }

        /deep/ .ivu-form-item-error-tip {
            top: 90%;
        }

        /deep/ .ivu-select-single .ivu-select-selection {
            height: 40px;

            .ivu-select-placeholder, .ivu-select-selected-value {
                height: 40px;
                line-height: 40px;
            }
        }
    }
</style>
